<template>
  <v-row>
    <v-col cols="6">
      <v-switch
        :input-value="active"
        :label="$t('generateDialog.activeEmail')"
        class="active-email-switch"
        hide-details="auto"
        @change="$emit('update:active', $event)"
      />
    </v-col>
    <v-col cols="6">
      <v-text-field
        :value="email"
        :label="$t('generateDialog.email')"
        outlined
        :disabled="!active"
        :error-messages="errors"
        hide-details="auto"
        @input="$emit('update:email', $event)"
        @blur="touched = true"
      />
    </v-col>
  </v-row>
</template>

<script>

import { emailValidator } from 'Mixins'

export default {
  mixins: [emailValidator],

  props: {
    email: {
      type: String,
      default: ''
    },
    active: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      touched: false
    }
  },

  computed: {
    validation () {
      if (!this.active) return []
      return this.emailValidationErrors(this.email)
    },
    errors () {
      return this.touched ? this.validation : []
    }
  },

  watch: {
    // Reset the "touched" state whenever the toggle changes (including a
    // parent-driven reset) so the error only reappears after interaction.
    active () {
      this.touched = false
    }
  },

  methods: {
    validate () {
      if (this.validation.length > 0) {
        this.touched = true
        return false
      }
      return true
    }
  }
}
</script>

<style lang="scss" scoped>

.active-email-switch ::v-deep .v-input__slot {
  width: fit-content;
}
</style>